ClipboardJS = require("clipboard");

// Attach Bulma plugins to all elements on page
document.addEventListener("turbolinks:load", function() {
  new ClipboardJS('.clipboard-button')
})
